import React from 'react';

export const CalendarIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" {...props}>
    <g stroke="#545D69" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.4 2.8H1.2v16.8h18.4V2.8h-3.2" />
      <path d="M6.8 4.4H4.4V1.2h2.4zM16.4 4.4H14V1.2h2.4zM6.8 2.316H14M1.2 6.358h18.4" />
    </g>
  </svg>
);
